import React, { useEffect, memo } from 'react';
import Name from 'components/Name';
import Price from 'components/Price';
import PriceMatch from 'components/PriceMatch/PriceMatch';
import PlansAlwaysOn from 'components/PlansAlwaysOn/PlansAlwaysOn';
import StarRating from 'components/RatingsAndReviews/StarRating';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { ProductDetailsProps } from './ProductDetailsProps';
import styles from './ProductDetails.module.css';

const ProductDetails = memo((props: ProductDetailsProps) => {
  const { brand, name, price, reviewTotal, reviewStars, productId, priceMatch, showPlansAlwaysOn } = props;
  const { selectedSku } = useSelectedSkuContext();
  const shouldRenderPriceMatch = priceMatch?.applicable === true;
  const shouldRenderReviews = Boolean(reviewTotal && reviewStars && reviewTotal > 0);

  useEffect(() => {
    if (productId) {
      document.querySelector('#product-detail')?.setAttribute('data-cnstrc-item-id', productId);
    }
  }, []);

  const reviewsSummary = shouldRenderReviews ? (
    <StarRating reviewTotal={reviewTotal!} reviewStars={reviewStars!} />
  ) : null;

  return (
    <div
      className={[styles.container, showPlansAlwaysOn && styles.plansAlwaysOn].filter(Boolean).join(' ')}
      data-testid="product-details"
      id="product-detail"
      data-cnstrc-product-detail
      data-cnstrc-item-name={name}
      data-cnstrc-item-price={price?.decimal}
      data-cnstrc-item-variation-id={selectedSku?.option}
    >
      <Name brand={brand} name={name} />
      {showPlansAlwaysOn ? (
        <>
          <Price price={price} />
          <PlansAlwaysOn />
          {(shouldRenderReviews || shouldRenderPriceMatch) && (
            <div className={styles.reviewsAndPriceMatch} data-testid="reviews-and-price-match">
              {reviewsSummary}
              {shouldRenderPriceMatch && <PriceMatch />}
            </div>
          )}
        </>
      ) : (
        <>
          <div className={styles.priceAndPriceMatch}>
            <Price price={price} />
            {shouldRenderPriceMatch && <PriceMatch />}
          </div>
          {reviewsSummary}
        </>
      )}
    </div>
  );
});

export default ProductDetails;
